export const getSlugFromEventCode = (eventCode: string, slugs: string[]) =>
    slugs.find((slug) => eventCode.startsWith(slug)) || null;
